import type { TwoEarliestUnpaidStatementMonthResponseType } from "@sellar-io/api-v2/types";
import { useMutation } from "@tanstack/react-query";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
} from "~/hooks/api/v2/apiV2Request";
import { useSellarCurrentBusiness } from "../../../../../../hooks/useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../../../../hooks/useFirebaseUser.shared";

export const useGetTwoEarliestUnpaidStatementMonth = <
  TData = TwoEarliestUnpaidStatementMonthResponseType,
>(
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `sellar-credit-management/two/earliest-unpaid-statement-month`,
      }).then((data) => apiV2AssertResponse<TData>(data).data),

    ...options,
  });
};
